import { Box, Text, Button } from "@chakra-ui/react";

interface Props {
  state: boolean;
  setState: any;
  ref: any;
  message: string;
}

const FormContactNotification = ({ state, setState, ref, message }: Props) => {
  return (
    <Box
      display={state ? "block" : "none"}
      p={["51px 25px", null, null, null, null, "90px 40px 62px"]}
      border="1px solid #D2D2F5"
      boxShadow="0px 5px 20px rgba(0, 0, 0, 0.25)"
      borderRadius="10px"
      bgColor="#ffffff"
      mb={["99px", null, null, null, null, "0px"]}
    >
      <Text
        as="h2"
        textStyle="h2"
        fontSize={["18px", null, null, null, null, "21px"]}
        fontWeight="300"
        mb="40px"
        ref={ref}
        lineHeight="1.4"
        whiteSpace="pre-wrap"
      >
        {message}
      </Text>
      <Button
        w="100%"
        minH="46px !important"
        height="46px !important"
        onClick={() => setState(false)}
      >
        Close
      </Button>
    </Box>
  );
};

export default FormContactNotification;
